import { LIVING_MINIMUM, CHILD_ALLOWANCE } from '../LegalParameters/Constants';

function getLivingMinimum(adult, children6, children15, children26, year) {
	if (adult === 1 && children6 + children15 + children26 === 0) {
		return LIVING_MINIMUM[year].SINGLE;
	}

	const adultMinimum =
		adult === 0
			? 0
			: LIVING_MINIMUM[year].FIRST_ADULT + (adult - 1) * LIVING_MINIMUM[year].OTHER_ADULT;
	const livingMinimum =
		adultMinimum +
		children6 * LIVING_MINIMUM[year].CHILDREN[0] +
		children15 * LIVING_MINIMUM[year].CHILDREN[1] +
		children26 * LIVING_MINIMUM[year].CHILDREN[2];

	return livingMinimum;
}

function getTotalChildAllowance(children6, children15, children26, allowance, year) {
	const increasedBy = allowance === 'ano' ? CHILD_ALLOWANCE[year].increasedBy : 0;

	return (
		children6 * (CHILD_ALLOWANCE[year].base[0] + increasedBy) +
		children15 * (CHILD_ALLOWANCE[year].base[1] + increasedBy) +
		children26 * (CHILD_ALLOWANCE[year].base[2] + increasedBy)
	);
}

export default function({ adult, children6, children15, children26, income, allowance, year }) {
	const livingMinimum = getLivingMinimum(adult, children6, children15, children26, year);

	const isAllowed = livingMinimum * CHILD_ALLOWANCE[year].livingMinimumThreshold > income;

	const total = isAllowed
		? getTotalChildAllowance(children6, children15, children26, allowance, year)
		: 0;

	return {
		isAllowed,
		livingMinimum,
		total,
	};
}
